import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { createBrowserRouter, RouterProvider } from "react-router-dom"
import { appRoutes } from "@/App"
import { store } from "@/app/store"
import { HelmetProvider } from "react-helmet-async"
import "@/styles/index.css"
import { registerSW } from "virtual:pwa-register"
import { setupInterceptors } from "./services/axiosSetup"
import "@/lib/firebase";  // Firebase 초기화
import { ThemeProvider } from "@/contexts/ThemeContext"

// PWA Service Worker 등록
const updateSW = registerSW({
  onNeedRefresh() {
    if (confirm("새 버전이 있습니다. 업데이트하시겠습니까?")) {
      updateSW()
    }
  },
  onOfflineReady() {
    console.log("앱이 오프라인에서 사용할 준비가 되었습니다!")
  },
})

// Axios 인터셉터 설정
setupInterceptors(store)

// 데이터 라우터 생성
const router = createBrowserRouter(appRoutes)

const container = document.getElementById("root")

if (container) {
  const root = createRoot(container)

  root.render(
    <StrictMode>
      <Provider store={store}>
        <HelmetProvider>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </HelmetProvider>
      </Provider>
    </StrictMode>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}
